import { defineComponent as _defineComponent } from 'vue';
import { trans, transChoice } from 'laravel-vue-i18n';
import Button from 'primevue/button';
import { ref } from 'vue';
import DetailValue from '../../../Components/DetailValue.vue';
import { useMitt } from '../../../Plugins/mitt';
import { concatPlotsCodes, formatISODate, getEnumKeyByValue, panelTitle, } from '../../../Services/Utils';
import { AffectedLeaves, AffectedZone } from '../../../@types/Enums';
import Sidebar from 'primevue/sidebar';
import SymptomRecordService from '../../../Services/SymptomRecordService';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Details',
    setup(__props, { expose }) {
        expose();
        const emitter = useMitt();
        const symptomRecordService = new SymptomRecordService();
        const data = ref();
        const title = ref('');
        const visible = ref(false);
        const edit = () => emitter.emit('open-symptom-record-form', data.value);
        emitter.on('symptom-record-saved', (data) => (data.value = data));
        const openEventName = 'open-symptom-record-details';
        emitter.off(openEventName);
        emitter.on(openEventName, async (eventData) => {
            data.value = await symptomRecordService.getById(eventData.id);
            title.value = panelTitle('SymptomRecordDetails', ': ' + eventData.code);
            visible.value = true;
        });
        const __returned__ = { emitter, symptomRecordService, data, title, visible, edit, openEventName, get trans() { return trans; }, get transChoice() { return transChoice; }, get Button() { return Button; }, DetailValue, get concatPlotsCodes() { return concatPlotsCodes; }, get formatISODate() { return formatISODate; }, get getEnumKeyByValue() { return getEnumKeyByValue; }, get AffectedLeaves() { return AffectedLeaves; }, get AffectedZone() { return AffectedZone; }, get Sidebar() { return Sidebar; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
